import { render, staticRenderFns } from "./RedteaReady-mobile.vue?vue&type=template&id=41078f67&scoped=true"
import script from "./RedteaReady-mobile.vue?vue&type=script&lang=js"
export * from "./RedteaReady-mobile.vue?vue&type=script&lang=js"
import style0 from "./RedteaReady-mobile.vue?vue&type=style&index=0&id=41078f67&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41078f67",
  null
  
)

export default component.exports